import { render, staticRenderFns } from "./yueDuTiSheng.vue?vue&type=template&id=252baed0&scoped=true&"
import script from "./yueDuTiSheng.vue?vue&type=script&lang=js&"
export * from "./yueDuTiSheng.vue?vue&type=script&lang=js&"
import style0 from "./yueDuTiSheng.vue?vue&type=style&index=0&id=252baed0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252baed0",
  null
  
)

export default component.exports